import { accessDeniedRoutes } from "../../routers/accessDeniedRoutes";
import { staticRoutes } from "../../routers/Routes";
import * as constants from "../constants";

const removeDuplicatedRoutes = (routes) => {
  const uniqueRoutes = [];
  const paths = new Set();

  for (let index = 0; index < routes.length; index++) {
    const route = routes[index];

    if (!paths.has(route.path)) {
      uniqueRoutes.push(route);
      paths.add(route.path);
    }
  }
  return [...uniqueRoutes];
};

const initialState = {
  isUserAuthenticated: false,
  routes: removeDuplicatedRoutes(staticRoutes).filter(
    ({ needAuthentication }) => !needAuthentication
  ),
};

export function userReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SET_IS_USER_AUTHENTICATED:
      return {
        ...state,
        isUserAuthenticated: action.isUserAuthenticated,
      };

    case constants.SET_ROUTES: {
      const allowed = removeDuplicatedRoutes([
        ...initialState.routes,
        ...action.routes,
      ]);

      // As rotas de módulo que a conta não tem entram no fim, com o estado de acesso
      // indisponível e fora do menu. Sem elas, digitar o endereço de um módulo não
      // contratado não casava com <Route> nenhum e a área de conteúdo ficava em branco
      // (MV2-1821). Depois das liberadas por garantia: se as duas casarem o mesmo
      // endereço, a liberada é a que a pessoa deve ver.
      return {
        ...state,
        routes: [...allowed, ...accessDeniedRoutes(staticRoutes, allowed)],
      };
    }
    default:
      return state;
  }
}
